export const GET_FEED = '/feed'
export const GET_STORIES = '/activities-users-stories'
